import _JSON$stringify from '/app/node_modules/babel-runtime/core-js/json/stringify';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
	name: 'CatalogFilter',

	props: {
		items: {
			type: Array,
			required: true
		},

		index: {
			type: Number
		}
	},

	computed: {
		lang: function lang() {
			return this.$store.state.settings.lang;
		},
		tags: function tags() {
			/*let label = this.$lang('filterAll', null, this.lang)
   return [{title: label}].concat(this.items)*/
			return this.items;
		},
		tag: function tag() {
			return this.$route.query.tag;
		},
		brand: function brand() {
			return this.$route.query.brand;
		},
		type: function type() {
			return this.$route.query.type;
		},
		filter: function filter() {
			return this.$route.query.filter || '';
		},
		filterArray: function filterArray() {
			return this.filter ? this.filter.split(',') : [];
		},
		page: function page() {
			return this.$route.query.page;
		},
		basePath: function basePath() {
			var str = this.$route.path + '?';

			if (this.tag) str = str + '&tag=' + this.tag;
			if (this.brand) str = str + '&brand=' + this.brand;
			if (this.type) str = str + '&type=' + this.type;

			return str.replace('&', '');
		},
		resetPath: function resetPath() {
			var _this = this;

			if (!this.filter) return '';

			var filter = this.filter.split(',').filter(function (el) {
				return el !== _this.current.tag;
			}).join(',');

			return filter ? '&filter=' + filter : '';
		},
		current: function current() {
			var _this2 = this;

			return this.tags.filter(function (item) {
				return ~_this2.filter.indexOf(item.tag);
			})[0] || {};
		}
	},

	methods: {
		setPath: function setPath(tag) {
			var _this3 = this;

			if (!tag) {
				if (!this.filter) return '';

				var filter = this.filter.split(',').filter(function (el) {
					return el !== _this3.current.tag;
				}).join(',');

				return filter ? '&filter=' + filter : '';
			}

			if (!this.filter) return '&filter=' + tag;

			if (this.current.tag) return '&filter=' + this.filter.replace(this.current.tag, tag);else return '&filter=' + this.filter + ',' + tag;
		},
		setPath2: function setPath2(tag) {
			var filter = JSON.parse(_JSON$stringify(this.filterArray));
			if (filter.includes(tag)) {
				filter.splice(filter.indexOf(tag), 1);
			} else {
				filter.push(tag);
			}
			return filter.length ? '&filter=' + filter.join(',') : '';
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/CatalogFilter.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/CatalogFilter.vue
// module chunks = 0